import {Component, Input, OnInit} from '@angular/core';
import {Resource} from "../../entities/Resource";

@Component({
  selector: 'app-resource-view',
  templateUrl: './resource-view.component.html',
  styleUrls: ['./resource-view.component.css']
})
export class ResourceViewComponent implements OnInit {

  @Input()
  resources : Resource[];

  siteTypes = ["card", "table"];

  siteType = this.siteTypes[0];

  searchInput : string;

  orderParameter : string;

  sortReverse : boolean;

  constructor() { }

  ngOnInit() {
  }

  setSiteType(type : string)
  {
    this.siteType = type;
  }

  setOrderParameter(para : string)
  {
    if(this.orderParameter == para)
    {
      this.sortReverse = !this.sortReverse;
    }
    this.orderParameter = para;
  }

}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/resource/resource-view.component.ts